// extracted by css-extract-rspack-plugin
export default {"content":"GV_Pos6___content","row":"XROj7EO___row","row_salary":"wH6M4ql___row_salary","rowSalary":"wH6M4ql___row_salary","title":"V5jQxoC___title","value":"DsxasYH___value"};